module.exports = __webpack_public_path__ + "img/binder.75d333b.svg";